// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__VK5RO","closeButton":"banner_closeButton__hbme7"};